var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/offer_discount_icon.f46c0597.png","uri@2x": __webpack_public_path__ + "static/media/offer_discount_icon.ac566d1c.png","uri@3x": __webpack_public_path__ + "static/media/offer_discount_icon.71f57163.png",
    width: 24,
    height: 25
});